<template>
  <div class="on-board-phase-2">
    <demo-tag />
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <router-view></router-view>
  </div>
</template>
<script>
import DemoTag from '@/components/on-board/DemoTag.vue'
import { mapGetters, mapActions } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'

export default {
  props: ['id'],
  mixins: [Fetcher],
    components: {DemoTag},
  computed: {
    ...mapGetters('onBoard', ['neofintechData'])
  },
  data() {
    return {
      isLoading: false
    }
  },
  created: function() {
    this.$store.commit('onBoard/SET_NEOFINTECH_PHASE_2_RESET')
  },
  mounted: function() {
    let self = this
    self.request(() =>
      self.getOnboardRequestDetails(this.id).then(function(response) {
        self.$store.commit(
          'onBoard/SET_NEOFINTECH_PHASE_1',
          response.data.phase1
        )
        self.$store.commit('onBoard/SET_NEOFINTECH_GENERAL', response.data)
      })
    )

  },
  methods: {
    ...mapActions('onBoard', ['getOnboardRequestDetails'])
  }
}
</script>
<style lang="scss">
@import '~@/scss/_mixins.scss';
.on-board-phase-2 {
  padding-bottom: 60px;
  height: 100%;
  overflow-y: scroll;
}

.world-background {
  background: url('~@/assets/hologram-map-background-yellow.svg') no-repeat;
  background-size: contain;
  background-position: center;
  height: 100%;
  >div {
    height: 100%;
  }
}
</style>

<style>
/* Page router animation animacion*/
.slide-enter-active,
.slide-leave-active {
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  overflow-x: hidden;
}

.slide-enter,
.slide-leave-active {
  opacity: 0;
  transform: translateX(-50px);
}
.container {
  transition: 0.3s ease-in-out;
}
</style>
